// Submit-once guard for forms marked `data-submit-once`.
//
// Craft deliberately delays the password-reset response by 0.5-1.5s (its
// preventUserEnumeration timing defence), and the button gives no sign it was
// pressed. People read that as a dead button and click again — one real user
// sent 8 POSTs in 32 seconds and hit Craft's 1-request-per-second IP rate
// limit, which used to land them on an unstyled 429. See #240.
document.addEventListener('submit', function (event) {

    var form = event.target;

    if (!form || !form.hasAttribute || !form.hasAttribute('data-submit-once')) {
        return;
    }

    if (form.dataset.submitted === 'true') {
        event.preventDefault();
        return;
    }

    form.dataset.submitted = 'true';

    // Disabling the button before the browser serialises the form would drop
    // its name/value from the POST, so defer to the next tick.
    window.setTimeout(function () {
        var buttons = form.querySelectorAll('button[type="submit"], input[type="submit"]');

        for (var i = 0; i < buttons.length; i++) {
            buttons[i].disabled = true;
            buttons[i].setAttribute('aria-busy', 'true');

            if (buttons[i].dataset.submittingLabel) {
                buttons[i].textContent = buttons[i].dataset.submittingLabel;
            }
        }
    }, 0);

});
